import InfoIcon from '@mui/icons-material/Info';
import { i18n } from 'i18n';
import Badge from '@mui/material/Badge';
import Skeleton from '@mui/material/Skeleton';
import Tooltip from '@mui/material/Tooltip';
import CircularProgressWithLabel from 'components/CircularProgressWithLabel';

const PREFIX = 'StopeProgress';

const classes = {
  infoBadge: `${PREFIX}-infoBadge`,
  tooltip: `${PREFIX}-tooltip`,
  progress: `${PREFIX}-progress`,
};

const NoDataProgressPlaceholder = () => (
  <Tooltip
    className={classes.tooltip}
    classes={{ tooltip: classes.tooltip }}
    title={i18n._('Progress not available as no data has been uploaded for this stope')}
  >
    <Badge className={classes.infoBadge} badgeContent={<InfoIcon color="secondary" />} overlap="circular">
      <Skeleton animation={false} variant="circular" width={65} height={65} />
    </Badge>
  </Tooltip>
);

interface StopeProgressProps {
  completedVolume: number;
  plannedVolume: number;
  volume?: number;
  size: number;
}

const StopeProgress = ({ completedVolume, plannedVolume, volume, size }: StopeProgressProps) => {
  if (!(volume)) {
    return <NoDataProgressPlaceholder />;
  }

  const planned = ((completedVolume + plannedVolume) / volume) * 100;
  const complete = (completedVolume / volume) * 100;

  return (
    <CircularProgressWithLabel
      value={complete}
      buffer={planned}
      thickness={5}
      color="secondary"
      size={size}
    />
  );
};

export default StopeProgress;
